// 权限控制

import router from "./router";
import store from "./store";

import { publicRouter } from "@/router";

import Cookie from "js-cookie";

const TOKEN_NAME = "grading-token";

// 网页加载进度条插件
import NProgress from "nprogress";
import "nprogress/nprogress.css"; // progress bar style
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

const whiteList = publicRouter.filter(v => v.name).map(v => v.name); // 免登录白名单

router.beforeEach((to, from, next) => {
  NProgress.start(); // start progress bar
  if (Cookie.get(TOKEN_NAME)) {
    // 有登录标记
    if (to.path == "/login") {
      //如果当前页面在登录页
      if (!store.getters.status) {
        // 当前用户还未拉取完user_info信息
        store.dispatch("getUserInfo").then(res => {
          console.log(1);

          router.addRoutes(store.getters.GenerateRoutes); // 动态添加可访问路由表

          next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
        });
      } else {
        next("/home");
      }
    } else {
      if (!store.getters.status) {
        store
          .dispatch("getUserInfo")
          .then(res => {
            router.addRoutes(store.getters.GenerateRoutes); // 动态添加可访问路由表
            next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
          })
          .catch(err => {
            Cookie.remove(TOKEN_NAME);
            next("/login");
          });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.name) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next("/login"); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});
